import React from 'react'
import {
  Button,
  Tooltip,
  Divider
} from 'antd'
import {LogoutOutlined,UserOutlined} from '@ant-design/icons'
import {useSelector,useDispatch} from 'react-redux'





export default function Navbar(props) {
  const user = useSelector(state=>state.auth.user)
  



  return (
    <div id="navbar">
      <h1 style={{fontSize:"40px",fontFamily:'Galada',color:"#002766"}}>{props.title}</h1>

      <div id="navbar-grp">
      
          <h3 style={{marginRight:"25px"}}>{user.displayName}</h3>
     
      

      <Tooltip placement="topLeft" title="Profile">
      <Button shape="round" onClick={()=>props.setProfileVisible(true)} style={{marginRight:"15px"}} icon={<UserOutlined />}></Button>
      
      </Tooltip>
     
     
      
      </div>
      
    </div>
  )
}
